import { render, staticRenderFns } from "./TestingofFrenchMiniStraw.vue?vue&type=template&id=34505ab3&scoped=true&"
import script from "./TestingofFrenchMiniStraw.vue?vue&type=script&lang=js&"
export * from "./TestingofFrenchMiniStraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34505ab3",
  null
  
)

export default component.exports